<script>
export default {
  name: "CatalogOrder",
  data() {
    return {
      isOpen: false,
      current: null,
    };
  },
  computed: {
    list() {
      return [
        {
          name: "price-desc",
          title: "Цена [высокая - низкая]",
        },
        {
          name: "price-asc",
          title: "Цена [низкая - высокая]",
        },
        {
          name: "weight-desc",
          title: "Вес [высокий - низкий]",
        },
        {
          name: "weight-asc",
          title: "Вес [низкий - высокий]",
        },
        {
          name: "size-desc",
          title: "Размеры [большой – маленький]",
        },
        {
          name: "size-asc",
          title: "Размеры [маленький – большой]",
        },
        {
          name: "novelty",
          title: "Новинки",
        },
        {
          name: "bestsellers",
          title: "Бестселлеры",
        },
      ];
    },
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    setOrder(value) {
      this.current = value;
      this.isOpen = false;
      window.dispatchEvent(
        new CustomEvent("setorder", {
          detail: {
            order: value,
          },
        })
      );
    },
  },
  mounted() {
    window.addEventListener("click", () => {
      this.isOpen = false;
    });
  },
};
</script>

<template>
  <div class="catalog-order" @click.stop>
    <button
      type="button"
      class="catalog-crumbs-action order"
      :class="{ open: isOpen }"
      @click="toggle"
    >
      Сортировка<icon-arrow-dropdown></icon-arrow-dropdown>
    </button>
    <div class="popup" :class="{ open: isOpen }">
      <div class="title">
        <button type="button" @click="toggle"><icon-arrow-prev /></button
        >Сортировка
      </div>
      <div class="list">
        <button
          v-for="item in list"
          :key="item.name"
          type="button"
          class="order-item"
          :class="{ current: current == item.name }"
          @click="setOrder(item.name)"
        >
          {{ item.title }}
        </button>
      </div>
      <button type="button" class="close" @click="toggle">Закрыть</button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.catalog-order {
  height: 50px;
}

.popup {
  position: relative;
  background-color: #fff;
  z-index: 15;
  border: 1px solid $color-border;
  margin-right: -1px;
  max-height: 0;
  transition: max-height 0.3s;
  overflow: hidden;
  border-bottom: none;

  &.open {
    max-height: 412px;
    border-bottom: 1px solid $color-border;
  }
}

.title {
  display: none;
}

.order-item {
  display: block;
  border: none;
  background: none;
  font-size: 16px;
  padding: 10px 30px 10px 30px;
  cursor: pointer;
  color: $color-text-grey;
  transition: color 0.3s;

  &:first-child {
    margin-top: 12px;
  }

  &:last-child {
    margin-bottom: 12px;
  }

  &.current {
    color: #000;
  }
}

.close {
  display: block;
  padding: 0;
  border: none;
  background: none;
  margin: 10px auto 25px auto;
  font-size: 16px;
  line-height: 1.4;
  border-bottom: 1px solid $color-border;
  cursor: pointer;
  transition: border-color 0.3s;

  &:hover {
    border-color: #000;
  }
}

@media (max-width: 1024px) {
  .page-crumbs .catalog-order .popup {
    position: fixed;
    left: 0;
    right: 0;
    top: var(--header-bottom);
    bottom: 0;
    height: auto;
    max-height: none;
    border: none;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.5s, visibility 0.5s;
    display: flex;
    flex-flow: column nowrap;
    align-items: stretch;
    justify-content: flex-start;

    &.open {
      opacity: 1;
      visibility: visible;
    }
  }

  .title {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    height: 50px;
    background: $color-white-ter;
    border-bottom: 1px solid $color-border;
    padding: 0 35px 0 35px;
    text-transform: uppercase;
    font-weight: 900;
    font-size: 14px;
    flex-shrink: 0;

    button {
      border: none;
      background: none;
      padding: 0;
      margin-right: 15px;

      .svg-icon {
        display: block;
        height: 14px;
      }
    }
  }

  .list {
    flex-grow: 1;
    flex-shrink: 1;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .close {
    @include black-button;

    display: block;
    height: 50px;
    width: 100%;
    margin: 0;
  }
}
</style>
